import { AfterViewInit, Component, Input, OnDestroy, ViewEncapsulation } from "@angular/core";
import Appcues from "@appcues/web-sdk";

@Component({
    selector: 'op-appcues-launchpad',
    template: `<div id="op-launchpad"></div>`,
    styleUrls: ["./opAppcuesLaunchpad.style.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: true
})
export class OpAppcuesLaunchpad implements AfterViewInit, OnDestroy {

    @Input() position: string = 'center';

    ngAfterViewInit(): void {
      Appcues.loadLaunchpad("#op-launchpad", { position: this.position });
    }

    ngOnDestroy(): void { }
}
